'use client';

import classNames from '@/utils/classNames';
import ButtonIcon from '@/components/Button/particles/ButtonIcon';
import BaseButton from '@/components/Button/particles/BaseButton';
import type { ButtonWithStaticIcon } from '@/components/Button/types';

import type { ComponentProps } from 'react';

const CLASSNAME =
  'bg-white not-disabled:text-greyscale-950 disabled:text-greyscale-950/30 not-disabled:hover:bg-stone-50 focus-visible:outline-blue-600';

const Button = (({ ref, ...props }: ComponentProps<typeof BaseButton>) => (
  <BaseButton
    ref={ref}
    {...props}
    className={classNames(CLASSNAME, props.className)}
  />
)) as ButtonWithStaticIcon;

Button.displayName = 'Button';

Button.Icon = ButtonIcon;

export default Button;
